const sportMen = [
  { title: "Shorts", icon: "icon1", subcategories: [] },
  { title: "Shirts", icon: "icon2", subcategories: [] },
  { title: "Joggers/Sweats", icon: "icon2", subcategories: [] },
  { title: "Jerseys", icon: "icon2", subcategories: [] },
  { title: "Sport Specific", icon: "icon2", subcategories: [] },
];
export default sportMen;
